import axios from 'src/utils/axios';
import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  hasError: false,
  comandas: [],
  filteredItems: [],
  rowsPerPage: 10,
  page: 0,
  filter: ''
};

const slice = createSlice({
  name: 'comandas',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.hasError = true;
    },

    // GET PRODUCTS
    getComandasSuccess(state, action) {
      state.isLoading = false;
      state.comandas = action.payload;
      state.filteredItems = action.payload;
    },

    changePageSuccess(state, action) {
      state.page = action.payload;
    },

    changeProductsPerPage(state, action) {
      state.rowsPerPage = action.payload;
    },

    filterElements(state, action) {
      state.filteredItems = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  getTicketsSuccess,
  changePageSuccess,
  changeProductsPerPage,
  filterElements
} = slice.actions;

// ----------------------------------------------------------------------

// 2026-09-03 · Semántica alineada con la vista /app/tpv/pedidos:
//   - Mesa con sesión activa: backend ignora el timelapse y devuelve las
//     comandas de la sesión actual (siempre lo relevante para el TPV).
//   - Mesa libre: backend aplica el filtro temporal (Last24Hours /
//     LastWeek / LastMonth; default = último año) igual que getOrders.
// El caller pasa el mismo `timeLapseSelected` que usa para getOrders
// (1=hoy, 2=semana, 3=mes, 4=año) para que ambos listados queden
// alineados temporalmente cuando la mesa está libre.
export function getComandas(idSession, timeLapseSelected) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const userId = window.localStorage.getItem('userId');
      const params = {
        last24Hours: timeLapseSelected === 1,
        lastWeek: timeLapseSelected === 2,
        lastMonth: timeLapseSelected === 3,
      };
      const response = await axios.get(
        `ticket/getComandas/${userId}/${idSession}`,
        { params }
      );
      dispatch(slice.actions.getComandasSuccess(response.data));
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function printComanda(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const userId = window.localStorage.getItem('userId');
      await axios.post(`ticket/PrintComanda/${userId}/${id}`);
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
